import script from "./MazdaAll.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaAll.vue?vue&type=script&setup=true&lang=js"

import "./MazdaAll.vue?vue&type=style&index=0&id=797fe7f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797fe7f8"]])

export default __exports__